import { Navigate, useLocation, useRoutes } from "react-router-dom";
import Login from "../pages/auth/Login";
import AuthLayout from "../layout/auth";
import PageTransition from "../components/UIElements/pageTransition";
import { AnimatePresence } from "framer-motion";
import React from "react";
import DashboardLayout from "../layout/dashboard";
import Dashboard from "../pages/dashboard";
import AuthGuard from "../hooks/useAuthGuard";
import Hospital from "../pages/hospital";
import HospitalDetails from "../pages/hospital/details";
import AddHospital from "../pages/hospital/add-hospital";
import Medic from "../pages/medic";
import MedicDetails from "../pages/medic/details";
import Profile from "../pages/profile";
import JobManagement from "../pages/job-management";
import JobManagementDetails from "../pages/job-management/details";
import Subscription from "../pages/subscription";
import Support from "../pages/support";
import SupportDetails from "../pages/support/details";
import UserManagement from "../pages/user";
import UsersDetails from "../pages/user/details";
import MedicEmployment from "../pages/medic/employment";
import Permissions from "../pages/user/permissions";
import HospitalEmployee from "../pages/hospital/employee";
import HospitalJobs from "../pages/hospital/jobs";
import FacilityJobDetails from "../pages/hospital/job-details";
import Cookies from "js-cookie";
import config from "../utils/config";
import ResetPassword from "../pages/auth/ResetPassword";
import OutsourcedJobs from "../pages/outsourcing";
import OutsourcedApplications from "../pages/outsourcing/applications";
import OutsourcedApplicationDetails from "../pages/outsourcing/application-details";

export default function Router() {
  const userData = Cookies.get(config.key.admin);
  const user_info =
    userData && userData.trim()
      ? JSON.parse(userData)
      : {
          role: "",
        };

  const routes = useRoutes([
    {
      path: "auth",
      element: <AuthLayout />,
      children: [
        {
          path: "sign-in",
          element: (
            <PageTransition>
              <Login />
            </PageTransition>
          ),
        },
        {
          path: "reset-password",
          element: (
            <PageTransition>
              {" "}
              <ResetPassword />
            </PageTransition>
          ),
        },
      ],
    },
    {
      path: "dashboard",
      element: <DashboardLayout />,
      children: [
        {
          path: "",
          element: (
            <AuthGuard>
              <PageTransition>
                <Dashboard />{" "}
              </PageTransition>
            </AuthGuard>
          ),
        },
      ],
    },
    {
      path: "hospital",
      element: <DashboardLayout />,
      children: [
        {
          path: "",
          element: (
            <AuthGuard>
              <PageTransition>
                <Hospital />{" "}
              </PageTransition>
            </AuthGuard>
          ),
        },

        {
          path: "add",
          element: (
            <AuthGuard>
              <PageTransition>
                <AddHospital />{" "}
              </PageTransition>
            </AuthGuard>
          ),
        },
        {
          path: ":id",
          element: (
            <AuthGuard>
              <PageTransition>
                <HospitalDetails />{" "}
              </PageTransition>
            </AuthGuard>
          ),
        },
        {
          path: ":id/employees",
          element: (
            <AuthGuard>
              <PageTransition>
                <HospitalEmployee />{" "}
              </PageTransition>
            </AuthGuard>
          ),
        },
        {
          path: ":id/jobs",
          element: (
            <AuthGuard>
              <PageTransition>
                <HospitalJobs />{" "}
              </PageTransition>
            </AuthGuard>
          ),
        },
        {
          path: ":id/jobs/:id",
          element: (
            <AuthGuard>
              <PageTransition>
                <FacilityJobDetails />{" "}
              </PageTransition>
            </AuthGuard>
          ),
        },
      ],
    },
    {
      path: "medic",
      element: <DashboardLayout />,
      children: [
        {
          path: "",
          element: (
            <AuthGuard>
              <PageTransition>
                <Medic />{" "}
              </PageTransition>
            </AuthGuard>
          ),
        },
        {
          path: ":id",
          element: (
            <AuthGuard>
              <PageTransition>
                <MedicDetails />{" "}
              </PageTransition>
            </AuthGuard>
          ),
        },
        {
          path: ":id/employment",
          element: (
            <AuthGuard>
              <PageTransition>
                <MedicEmployment />{" "}
              </PageTransition>
            </AuthGuard>
          ),
        },
      ],
    },
    {
      path: "users",
      element: <DashboardLayout />,
      children: [
        {
          path: "",
          element: (
            <AuthGuard>
              <PageTransition>
                <UserManagement />
              </PageTransition>
            </AuthGuard>
          ),
        },
        {
          path: "permissions",
          element: (
            <AuthGuard>
              <PageTransition>
                <Permissions />
              </PageTransition>
            </AuthGuard>
          ),
        },
        {
          path: ":id",
          element: (
            <AuthGuard>
              {user_info.role === "superAdmin" ? (
                <PageTransition>
                  <UsersDetails />
                </PageTransition>
              ) : (
                <Navigate to={"/dashboard"} />
              )}
            </AuthGuard>
          ),
        },
      ],
    },
    {
      path: "job-management",
      element: <DashboardLayout />,
      children: [
        {
          path: "",
          element: (
            <AuthGuard>
              <PageTransition>
                {" "}
                <JobManagement />
              </PageTransition>
            </AuthGuard>
          ),
        },

        {
          path: ":id",
          element: (
            <PageTransition>
              <JobManagementDetails />
            </PageTransition>
          ),
        },
      ],
    },
    {
      path: "outsourcing",
      element: <DashboardLayout />,
      children: [
        {
          path: "",
          element: (
            <AuthGuard>
              <PageTransition>
                <OutsourcedJobs />
              </PageTransition>
            </AuthGuard>
          ),
        },
        {
          path: ":requestId/applications",
          element: (
            <AuthGuard>
              <PageTransition>
                <OutsourcedApplications />
              </PageTransition>
            </AuthGuard>
          ),
        },
        {
          path: ":requestId/applications/:applicationId",
          element: (
            <AuthGuard>
              <PageTransition>
                <OutsourcedApplicationDetails />
              </PageTransition>
            </AuthGuard>
          ),
        },
      ],
    },
    {
      path: "support",
      element: <DashboardLayout />,
      children: [
        {
          path: "",
          element: (
            <PageTransition>
              <Support />
            </PageTransition>
          ),
        },
      ],
    },

    {
      path: "subscription",
      element: <DashboardLayout />,
      children: [
        {
          path: "",
          element: (
            <PageTransition>
              <Subscription />
            </PageTransition>
          ),
        },
      ],
    },
    {
      path: "profile",
      element: <DashboardLayout />,
      children: [
        {
          path: "",
          element: (
            <PageTransition>
              <Profile />
            </PageTransition>
          ),
        },
      ],
    },

    {
      path: "*",
      element: <Navigate to="/auth/sign-in" />,
    },
  ]);

  const location = useLocation();
  if (!routes) return null;

  return (
    <AnimatePresence>
      {React.cloneElement(routes, { key: location.pathname })}

      {/* {routes ? React.cloneElement(routes, { key: location.pathname }) : null} */}
      {/* {routes && React.cloneElement(routes, { key: location.pathname })} */}
    </AnimatePresence>
  );
}
